import { connect } from "react-redux";
import { ApplicationState } from "store";
import { actionCreators, getCalendar } from "page/calendar/store";
import {
    actionCreators as uiActionCreators,
    getValidRubberBands,
} from "ui/store";
import RubberBandPicker from "./cover-rubberband-picker";
import { getResource } from "resource/store";

const mapStateToProps = (state: ApplicationState) => ({
    validRubberBands: getValidRubberBands(state),
    calendar: getCalendar(state),
    Binding_Rubberband: getResource(state, { key: "Binding_Rubberband" }),
});

const mapDispatchToProps = {
    ...actionCreators,
    ...uiActionCreators,
};

export default connect(mapStateToProps, mapDispatchToProps)(RubberBandPicker);
